import { render, staticRenderFns } from "./VersionesLista.vue?vue&type=template&id=64215951&scoped=true"
import script from "./VersionesLista.vue?vue&type=script&lang=js"
export * from "./VersionesLista.vue?vue&type=script&lang=js"
import style0 from "./VersionesLista.vue?vue&type=style&index=0&id=64215951&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64215951",
  null
  
)

export default component.exports